import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ShieldCheck, ShieldX } from "lucide-react";
import axios from "axios";
import { LOGO } from "@/lib/kop";
import { tglID } from "@/lib/suratTemplates";

export default function Verifikasi() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/verifikasi/${id}`).then((r) => setD(r.data)).catch((e) => setErr(e?.response?.data?.detail || "Surat tidak ditemukan"));
  }, [id]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#0b1f33] px-4 py-10" data-testid="verifikasi-page">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden">
        <div className="papua-trim" />
        <div className="p-6 flex items-center gap-3 border-b">
          <img src={LOGO} alt="Logo" className="h-12" />
          <div><div className="font-display font-bold">TAPARU INAUGA</div><div className="text-xs text-slate-500">Verifikasi Keaslian Surat · Kelurahan Inauga</div></div>
        </div>
        <div className="p-6">
          {err && <div className="flex items-center gap-3 text-rose-700" data-testid="verifikasi-invalid"><ShieldX className="h-8 w-8" /><div className="font-semibold">{err}</div></div>}
          {d && (
            <>
              <div className="flex items-center gap-3 text-emerald-700" data-testid="verifikasi-valid"><ShieldCheck className="h-8 w-8" /><div className="font-semibold">Surat SAH dan terdaftar</div></div>
              <dl className="mt-5 space-y-3 text-sm">
                {[["Nomor", d.nomor], ["Jenis Surat", d.judul], ["Tanggal", tglID(d.tanggal)], ["Atas Nama", d.nama], ["NIK", d.nik], ["Ditandatangani", `${d.pejabat} (${d.jabatan})`], ["Tanda Tangan Elektronik", d.ttd_elektronik ? "Ya" : "Tidak"]].map(([k, v]) => (
                  <div key={k} className="border-b pb-2"><dt className="text-[11px] uppercase tracking-wide text-slate-500">{k}</dt><dd className="font-medium text-slate-900">{v}</dd></div>
                ))}
              </dl>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
